import  { useState, useEffect } from 'react';
import { Building2, MapPin, Euro, Truck } from 'lucide-react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from '../../i18n/i18n';
import ReusableTable from '../../components/Tableau';
import { useNavigate } from 'react-router-dom';
import api from '../../api/axios';
// import SupplierModal from '../../components/Modals/SupplierModal';


const SuppliersPage = ({ lang }) => {
  const { t } = useTranslation(lang);
  // const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState([]);
  const supplierURL = process.env.REACT_APP_API_PROVIDER_URL;

  // Fonction pour récupérer tous les fournisseurs
const fetchAllSuppliers = async () => {
  try {
    setLoading(true);

    const urlBase = supplierURL;
    
    // Définir le body correctement
    const baseRequestBody = {
      search: "",
      status: ""
    };

    // 1. Charger la page 1
    const firstResponse = await api.post(urlBase, baseRequestBody, {
      params: { page: 1 } 
    });
        
    const firstData = firstResponse.data;

    const lastPage = firstData.last_page;

    // Formater les données
    let allSuppliers = firstData.result.data.map(formatSupplier);

    // 2. Charger les autres pages EN PARALLÈLE
    const promises = [];

    for (let page = 2; page <= lastPage; page++) {
      promises.push(
        api.post(urlBase, baseRequestBody, {
          params: { page: page }
        })
        .then(res => res.data.result.data.map(formatSupplier))
      );
    }

    const pagesResults = await Promise.all(promises);

    pagesResults.forEach(page => {
      allSuppliers.push(...page);
    });

    // 3. Mettre à jour l'état
    setSuppliers(allSuppliers);

  } catch (err) {
    console.error("Erreur API détaillée:", err);
    if (err.response) {
      console.error("Status:", err.response.status);
      console.error("Data:", err.response.data);
      console.error("Headers:", err.response.headers);
    }
  } finally {
    setLoading(false);
  }
};


  // Fonction pour formater les données de l'API
  const formatSupplier = (supplier) => {
    return {
      id: supplier.id,
      name: `${supplier.name} [${supplier.country?.name || ''}]`,
      email: supplier.email,
      phone: supplier.phone,
      // Informations supplémentaires pour une éventuelle future utilisation
      country: supplier.country?.name || '',
      currency: supplier.currency || '',
      city: supplier.city?.name || '',
      provider_type: supplier.type?.name || '',
      website: supplier.website,
      address: supplier.address
    };
  };

  // Charger les fournisseurs au montage du composant
  useEffect(() => {
    fetchAllSuppliers();
  }, []);

//     const handleAddUser = () => {
//   setShowSupplierModal(true);
// };

  // Calculer le nombre de pays uniques
  const uniqueCountries = [...new Set(suppliers.map(s => s.country))].filter(Boolean);
  const uniqueCurrencies = [...new Set(suppliers.map(s => s.currency))].filter(Boolean);

  // Cartes de statistiques
  const supplierStats = [
    {
      title: t('totalSuppliers'),
      value: suppliers.length.toString(),
      description: t('allSuppliers'),
      icon: Building2,
      color: '#7c3aed',
    },
{
  title: t('currencies'),
  value: uniqueCurrencies.length.toString(),
  description: t('differentCurrencies'),
  icon: Euro, 
  color: '#f59e0b', 
},
    {
      title: t('countries'),
      value: uniqueCountries.length.toString(),
      description: t('operatingCountries'),
      icon: MapPin,
      color: '#3b82f6',
    }
  ];

  // Colonnes du tableau - j'ai ajouté le type de fournisseur comme info intéressante
  const supplierColumns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: t('name') },
    { key :'address', label: t('address')},
    { key: 'email', label: t('email') },
    { key: 'phone', label: t('phone') },
    { key: 'provider_type', label: t('type') }
  ];

  const handleDetails = (supplier) => {
    navigate(`/suppliers/${supplier.id}`);
  };

  // Handler pour le click sur la ligne
  const handleRowClick = (supplier) => {
    handleDetails(supplier);
  };

  const styles = {
    container: {
      padding: '24px',
      background: '#f9fafb',
      minHeight: '100vh'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '32px'
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px'
    },
    title: {
      fontSize: '28px',
      fontWeight: 'bold',
      color: '#1f2937',
      margin: 0
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '15px',
      marginBottom: '32px'
    },
    statCard: {
      background: 'white',
      padding: '20px',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease'
    },
    statIcon: {
      width: '56px',
      height: '56px',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    statContent: {
      flex: 1
    },
    statValue: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '4px'
    },
    statTitle: {
      fontSize: '14px',
      color: '#6b7280',
      marginBottom: '4px',
      fontWeight: '600'
    },
    statDescription: {
      fontSize: '12px',
      color: '#9ca3af'
    },
        addButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '12px 20px',
      backgroundColor: '#7c3aed',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '600',
      transition: 'all 0.2s ease'
    }
  };

  return (
    <div style={styles.container}>
      {/* Header avec titre */}
      <div style={styles.header}>
        <div style={styles.titleContainer}>
          <Truck size={32} color="#7c3aed" />
          <h1 style={styles.title}>{t('suppliersManagement')}</h1>
        </div>
                {/* <button 
          style={styles.addButton}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#6d28d9'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#7c3aed'}
          onClick={handleAddUser}
        >
          <Plus size={20} />
          {t('addSupplier')}
        </button> */}
      </div>

      {/* Cartes de statistiques */}
      <div style={styles.statsGrid}>
        {supplierStats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div
              key={index}
              style={styles.statCard}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
              }}
            >
              <div style={{
                ...styles.statIcon,
                background: `linear-gradient(135deg, ${stat.color} 0%, ${stat.color}dd 100%)`
              }}>
                <Icon size={28} color="white" />
              </div>
              <div style={styles.statContent}>
                <div style={styles.statValue}>{stat.value}</div>
                <div style={styles.statTitle}>{stat.title}</div>
                <div style={styles.statDescription}>{stat.description}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Tableau des fournisseurs */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <p>{t('loading')}</p>
        </div>
      ) : (
        <ReusableTable
          data={suppliers}
          columns={supplierColumns}
          onDetails={handleDetails}
          onRowClick={handleRowClick}
          lang={lang}
          itemsPerPageOptions={[10, 20, 50, 100]}
          colors={{
            headerBg: '#7c3aed',
            buttonDetails: '#10b981'
          }}
          showEditButton={false}
          showDeleteButton={false}
        />
      )}

            {/* {showSupplierModal && (
  <SupplierModal
    type={'edit'}
    onClose={() => setShowSupplierModal(false)}
    onSave={() => {
      toast.success(t('supplierUpdatedSuccess'));
      setShowSupplierModal(false);
    }}
    lang={lang}
  />
)} */}

      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default SuppliersPage;